module.exports = __webpack_public_path__ + "img/bonus-card.16bce8fe.svg";